import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDown, LayoutDashboard, CalendarRange, CalendarClock, Users, GraduationCap, Megaphone, Wallet, FileText, Tag, SlidersHorizontal, Percent, CreditCard, Building2, Store, MapPin, ShieldCheck, Users2, Settings, } from 'lucide-react';
import { ROUTES } from '@/core/config/routes';
import { cn } from '@/core/utils/cn';
import { env } from '@/core/config/env';
import { useSession } from '@/core/auth/useSession';
const GRUPOS = [
    {
        titulo: 'Operación',
        items: [
            { label: 'Dashboard', to: ROUTES.dashboard, icono: LayoutDashboard },
            { label: 'Reservas', to: ROUTES.reservas, icono: CalendarRange, anyOf: ['ROLE_VER_RESERVA'] },
            {
                label: 'Clases',
                to: ROUTES.clases,
                icono: CalendarClock,
                anyOf: ['ROLE_ASIGNAR_INSTRUCTOR', 'ROLE_CAMBIAR_INSTRUCTOR'],
            },
            {
                label: 'Mis clases',
                to: ROUTES.misClases,
                icono: CalendarClock,
                anyOf: ['ROLE_MARCAR_CLASE_DICTADA'],
                noneOf: ['ROLE_ASIGNAR_INSTRUCTOR'],
            },
            { label: 'Clientes', to: ROUTES.clientes, icono: Users, anyOf: ['ROLE_VER_CLIENTE'] },
        ],
    },
    {
        titulo: 'Gente',
        items: [
            { label: 'Instructores', to: ROUTES.empleados, icono: GraduationCap, anyOf: ['ROLE_VER_EMPLEADO'] },
            { label: 'Promotores', to: ROUTES.promotores, icono: Megaphone, anyOf: ['ROLE_VER_PROMOTOR'] },
            {
                label: 'Disciplinas y niveles',
                to: ROUTES.gente.disciplinasNiveles,
                icono: SlidersHorizontal,
                anyOf: ['ROLE_ADMINISTRAR_EMPLEADO'],
            },
        ],
    },
    {
        titulo: 'Finanzas',
        items: [
            { label: 'Pagos', to: ROUTES.pagos, icono: Wallet, anyOf: ['ROLE_VER_PAGO'] },
            { label: 'Liquidaciones', to: ROUTES.liquidaciones, icono: FileText, anyOf: ['ROLE_VER_LIQUIDACION'] },
            { label: 'Anticipos', to: ROUTES.anticipos, icono: Wallet, anyOf: ['ROLE_GENERAR_LIQUIDACION'] },
        ],
    },
    {
        titulo: 'Catálogo',
        items: [
            { label: 'Tarifas', to: ROUTES.catalogo.tarifas, icono: Tag, anyOf: ['ROLE_VER_TARIFA'] },
            {
                label: 'Descuentos',
                to: ROUTES.catalogo.descuentos,
                icono: Percent,
                anyOf: ['ROLE_ADMINISTRAR_DESCUENTO'],
            },
            {
                label: 'Métodos de pago',
                to: ROUTES.catalogo.metodosPago,
                icono: CreditCard,
                anyOf: ['ROLE_ADMINISTRAR_SUCURSAL'],
            },
        ],
    },
    {
        titulo: 'Organización',
        items: [
            { label: 'Sucursales', to: ROUTES.organizacion.sucursales, icono: Building2, anyOf: ['ROLE_VER_SUCURSAL'] },
            {
                label: 'Puntos de venta',
                to: ROUTES.organizacion.pdv,
                icono: Store,
                anyOf: ['ROLE_ADMINISTRAR_SUCURSAL'],
            },
            {
                label: 'Puntos de encuentro',
                to: ROUTES.organizacion.puntosEncuentro,
                icono: MapPin,
                anyOf: ['ROLE_ADMINISTRAR_SUCURSAL'],
            },
        ],
    },
    {
        titulo: 'Administración',
        items: [
            {
                label: 'Usuarios',
                to: ROUTES.admin.usuarios,
                icono: ShieldCheck,
                anyOf: ['ROLE_ADMINISTRAR_USUARIO'],
            },
            {
                label: 'Grupos y permisos',
                to: ROUTES.admin.grupos,
                icono: Users2,
                anyOf: ['ROLE_ADMINISTRAR_USUARIO'],
            },
            {
                label: 'Parámetros',
                to: ROUTES.admin.parametros,
                icono: Settings,
                anyOf: ['ROLE_ADMINISTRAR_SISTEMA', 'ROLE_ADMINISTRAR_PARAMETROS'],
            },
        ],
    },
];
const STORAGE_KEY = 'ssc-sidebar-colapsados';
function leerColapsados() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return [];
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.map(String) : [];
    }
    catch {
        return [];
    }
}
export function Sidebar() {
    const { tieneRol, tieneAlgunRol } = useSession();
    const [colapsados, setColapsados] = useState(() => new Set(leerColapsados()));
    const puedeVer = (item) => {
        if (item.noneOf && item.noneOf.some((r) => tieneRol(r)))
            return false;
        if (!item.anyOf || item.anyOf.length === 0)
            return true;
        return tieneAlgunRol(item.anyOf);
    };
    const gruposVisibles = GRUPOS
        .map((g) => ({ ...g, items: g.items.filter(puedeVer) }))
        .filter((g) => g.items.length > 0);
    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(colapsados)));
        }
        catch {
            /* ignore */
        }
    }, [colapsados]);
    const toggle = (titulo) => {
        setColapsados((prev) => {
            const next = new Set(prev);
            if (next.has(titulo))
                next.delete(titulo);
            else
                next.add(titulo);
            return next;
        });
    };
    return (_jsxs("aside", { className: "sticky top-0 flex h-screen w-[212px] flex-col border-r border-white/5", style: { backgroundColor: '#0F172A' }, children: [_jsxs("div", { className: "flex h-12 items-center gap-2 border-b border-white/5 px-3", children: [_jsx("div", { className: "flex h-7 w-7 items-center justify-center rounded-md bg-primary text-[13px] font-bold text-primary-contrast", children: "S" }), _jsxs("div", { className: "flex flex-col leading-none", children: [_jsx("span", { className: "text-[13px] font-semibold text-white", children: "SSC" }), _jsx("span", { className: "text-[10px] text-slate-400", children: "Gesti\u00F3n" })] })] }), _jsx("nav", { className: "flex-1 overflow-y-auto px-1.5 py-2", children: gruposVisibles.map((grupo) => {
                    const abierto = !colapsados.has(grupo.titulo);
                    return (_jsxs("div", { className: "mb-2", children: [_jsxs("button", { type: "button", onClick: () => toggle(grupo.titulo), "aria-expanded": abierto, className: "flex w-full items-center justify-between gap-1 rounded-md px-1.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400 transition hover:text-slate-200", children: [_jsx("span", { children: grupo.titulo }), _jsx(ChevronDown, { className: cn('h-3 w-3 transition-transform duration-150', !abierto && '-rotate-90') })] }), abierto ? (_jsx("ul", { className: "mt-0.5 flex flex-col", children: grupo.items.map((item) => {
                                    const Icono = item.icono;
                                    return (_jsx("li", { children: _jsxs(NavLink, { to: item.to, className: ({ isActive }) => cn('flex items-center gap-2 rounded-md px-1.5 py-1 text-[13px] leading-tight transition', isActive
                                                ? 'bg-primary/15 font-medium text-primary'
                                                : 'text-slate-300 hover:bg-white/5 hover:text-white'), children: [_jsx(Icono, { className: "h-3.5 w-3.5 flex-shrink-0", strokeWidth: 1.75 }), _jsx("span", { className: "truncate", children: item.label })] }) }, item.to));
                                }) })) : null] }, grupo.titulo));
                }) }), _jsxs("div", { className: "border-t border-white/5 px-3 py-1.5 text-[10px] text-slate-500", children: ["v", env.appVersion] })] }));
}
